
import Checklist from 'vux/src/components/checklist/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'



export default {
name: "manager-detail",
components: {
Checklist,
XButton,
XSwitch,
Group,
XInput
},
data(){
return {
shopId: this.$route.params.shopId,
isSuperManager: false,
disableControl : false,
operatorName: null,
operatorPhone: null,
operatorPermissions: [],
permissionsList: [],
errFlag: false,
errMsg: '',
okFlag: false,
okMsg: '操作成功'
}
},
created(){
this.getPermissionsList();
this.getOperatorDetail();
},
methods: {
getOperatorDetail() {
let shopId = this.shopId
let managerId = this.$route.params.managerId
let _this = this;
let uri = '/v1/shop/'+ shopId +'/manage/operator/'+ managerId +'/detail';
let params = null;
_this.axios.get(uri, params, {
headers: {}
}).then(function (response) {
if (response.data.code != undefined && response.data.code == 0) {
_this.operatorName = response.data.data.real_name
_this.operatorPhone = response.data.data.mobile
_this.isSuperManager = response.data.data.is_admin ? true : false
_this.operatorPermissions = response.data.data.permissions
} else {
_this.errorMsg('处理错误提醒')

}
}).catch(function (response) {
console.log(response);

});
},
getPermissionsList() {
let _this = this;
let uri = '/system/shop/permissions';
let params = {
}
_this.axios.get(uri, params, {
headers: {}
}).then(function (response) {
if (response.data.code == 0) {
_this.permissionsList = response.data.data
}
}).catch(function (response) {
console.log(response);
});
},
successMsg(msg){
this.okFlag = true
this.okMsg = msg
},
errorMsg(msg){
this.errFlag = true
this.errMsg = msg
}
}
}



// WEBPACK FOOTER //
// ./src/components/manage/ManagerDetail.vue